import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { USER_ROLE } from '../../enums/user-role.enum';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  constructor(public authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.subscription.add(
      combineLatest([
        this.authService.isAuthenticated(),
        this.authService.initializationComplete
      ]).pipe(
        filter(([isAuthenticated, initComplete]) =>
          isAuthenticated === true && initComplete === true
        ),
        take(1)
      ).subscribe(() => {
        this.redirectBasedOnRole();
      })
    );
  }


  private redirectBasedOnRole(): void {
    const userRole = this.authService.getUserRoleFromLocalStorage();

    switch (userRole) {
      case USER_ROLE.ADMIN:
        this.router.navigate(['/admin/dashboard']);
        break;
      case USER_ROLE.GYM:
        this.router.navigate(['/dashboard']);
        break;
      default:
        return;
    }
  }

  login(): void {
    this.authService.login().subscribe();
  }

  openFaq(): void {
    // Open FAQ page or modal
    window.open('https://easy-fitpass.com/#faq', '_blank');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
